export default {
  container: { display: 'inline-flex', flexWrap: 'wrap', gap: '12px', margin: '20px' },
};
